import {
    GET_THREAD_DETAILS_START,
    GET_THREAD_DETAILS_SUCCESS,
    GET_THREAD_DETAILS_FAIL,
    GET_DEALERSHIP_DETAILS_START,
    GET_DEALERSHIP_DETAILS_SUCCESS,
    GET_DEALERSHIP_DETAILS_FAIL,
    UPDATE_ANSWER_MODE_START,
    UPDATE_ANSWER_MODE_SUCCESS,
    UPDATE_ANSWER_MODE_FAIL,
    GET_USER_DETAILS_START,
    GET_USER_DETAILS_SUCCESS,
    GET_USER_DETAILS_FAIL,
    UPDATE_SUBSCRIPTION_START,
    UPDATE_SUBSCRIPTION_SUCCESS,
    UPDATE_SUBSCRIPTION_FAIL,
    UPDATE_INTEREST_STATUS_START,
    UPDATE_INTEREST_STATUS_SUCCESS,
    UPDATE_INTEREST_STATUS_FAIL,
    GET_ELEAD_URL_START,
    GET_ELEAD_URL_SUCCESS,
    GET_ELEAD_URL_FAIL,
    GENERATE_ANSWER_START,
    GENERATE_ANSWER_SUCCESS,
    GENERATE_ANSWER_FAIL,
    GET_USER_SUBSCRIPTION_SUCCESS,
} from './constants'

export default (state = {}, action) => {
    let newState

    switch (action.type) {
        case GET_THREAD_DETAILS_START:
            newState = {
                ...state,
                threadDetailsLoading: true,
                threadDetails: {},
            }
            break
        case GET_THREAD_DETAILS_SUCCESS:
            {
                const { payload } = action
                newState = {
                    ...state,
                    threadDetailsLoading: false,
                    threadDetails: payload,
                }
            }
            break
        case GET_THREAD_DETAILS_FAIL:
            newState = {
                ...state,
                threadDetailsLoading: false,
                threadDetails: {},
            }
            break
        case GET_DEALERSHIP_DETAILS_START:
            newState = {
                ...state,
                dealershipDetailsLoading: true,
                dealershipDetails: {},
            }
            break
        case GET_DEALERSHIP_DETAILS_SUCCESS:
            {
                const { payload } = action
                newState = {
                    ...state,
                    dealershipDetailsLoading: false,
                    dealershipDetails: payload,
                }
            }
            break
        case GET_DEALERSHIP_DETAILS_FAIL:
            newState = {
                ...state,
                dealershipDetailsLoading: false,
                dealershipDetails: {},
            }
            break
        case UPDATE_ANSWER_MODE_START:
            newState = {
                ...state,
                setAnswerMode: false,
            }
            break
        case UPDATE_ANSWER_MODE_SUCCESS:
            newState = {
                ...state,
                setAnswerMode: true,
            }
            break
        case UPDATE_ANSWER_MODE_FAIL:
            newState = {
                ...state,
                setAnswerMode: false,
            }
            break
        case GET_USER_DETAILS_START:
            newState = {
                ...state,
                userDetailsLoading: true,
                userDetails: {},
            }
            break
        case GET_USER_DETAILS_SUCCESS:
            {
                const { payload } = action

                newState = {
                    ...state,
                    userDetailsLoading: false,
                    userDetails: payload,
                }
            }
            break
        case GET_USER_DETAILS_FAIL:
            newState = {
                ...state,
                userDetailsLoading: false,
                userDetails: {},
            }
            break
        case UPDATE_SUBSCRIPTION_START:
        case UPDATE_INTEREST_STATUS_START:
            newState = {
                ...state,
                userDetailsLoading: true,
            }
            break
        case UPDATE_SUBSCRIPTION_SUCCESS:
            {
                // const { payload } = action
                let { userDetails } = state

                userDetails = {
                    ...userDetails,
                }

                newState = {
                    ...state,
                    userDetails,
                    userDetailsLoading: false,
                    shouldRefetchSubs: Math.random(),
                }
            }
            break
        case UPDATE_INTEREST_STATUS_SUCCESS:
            {
                const { payload } = action
                let { userDetails } = state

                userDetails = {
                    ...userDetails,
                    InterestStatus: payload,
                }

                newState = {
                    ...state,
                    userDetails,
                    userDetailsLoading: false,
                }
            }
            break
        case UPDATE_SUBSCRIPTION_FAIL:
        case UPDATE_INTEREST_STATUS_FAIL:
            newState = {
                ...state,
                userDetailsLoading: false,
            }
            break
        case GET_ELEAD_URL_START:
            newState = {
                ...state,
                eleadUrl: '',
                eleadUrlLoading: true,
            }
            break
        case GET_ELEAD_URL_SUCCESS:
            {
                const { payload } = action

                newState = {
                    ...state,
                    eleadUrl: payload,
                    eleadUrlLoading: false,
                }
            }
            break
        case GET_ELEAD_URL_FAIL:
            newState = {
                ...state,
                eleadUrl: '',
                eleadUrlLoading: false,
            }
            break
        case GENERATE_ANSWER_START:
            newState = {
                ...state,
                generateAnswerLoading: true,
            }
            break
        case GENERATE_ANSWER_SUCCESS:
            newState = {
                ...state,
                generateAnswerLoading: false,
            }
            break
        case GENERATE_ANSWER_FAIL:
            newState = {
                ...state,
                generateAnswerLoading: false,
            }
            break
        case GET_USER_SUBSCRIPTION_SUCCESS:
            newState = {
                ...state,
                subscriptionStatuses: action.payload,
            }
            break
        default:
            newState = state
            break
    }

    return newState
}
